import UserResearch from './UserResearch';

export default UserResearch;